
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { User } from "@supabase/supabase-js";
import { identifyUser } from "@/utils/logRocketUtils";
import { ApplicationError } from "@/lib/errors/types";

export const useAuthSession = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    const setupAuth = async () => {
      try {
        // 1. Set up auth state listener first
        const { data: { subscription } } = supabase.auth.onAuthStateChange(
          async (event, session) => {
            console.log('Auth state changed:', event, session?.user?.id);
            
            if (session?.user) {
              setUser(session.user);
              // Update LogRocket user info
              identifyUser({
                id: session.user.id,
                email: session.user.email,
                name: session.user.user_metadata?.full_name
              });
            } else {
              setUser(null);
            }
            setLoading(false);
          }
        );

        // 2. Then check current session
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
          setUser(session.user);
          identifyUser({
            id: session.user.id,
            email: session.user.email,
            name: session.user.user_metadata?.full_name
          });
        }
        setLoading(false);

        return () => {
          subscription.unsubscribe();
        };
      } catch (error) {
        console.error('Auth setup error:', error);
        setLoading(false);
        throw new ApplicationError(
          'Erreur lors de l\'initialisation de l\'authentification',
          'error',
          { originalError: error }
        );
      }
    };

    setupAuth();
  }, []);

  return { user, loading };
};
